// @flow

// todo mover a src/components porque es compartido
import React from "react";
import styled from "styled-components";
import theme from "views/resources/theme";
import Icon, { Icons } from "react-hp-icons";
import { UserOutlined } from "@ant-design/icons";
import type { InlineProps, WaitingProps } from "./types";

const InlineWaiting = ({
	waiting = NaN,
	size = 1,
	color = theme.colors.fg,
}: InlineProps & WaitingProps) =>
	!isNaN(waiting) && (
		<Wrapper>
			<UserOutlined
				style={{
					color: "#096DD9",
					fontSize: 12,
					alignSelf: "center",
					paddingRight: 2,
					paddingBottom: 1,
				}}
			/>
			<span>{waiting} en fila</span>
		</Wrapper>
	);

const Wrapper = styled.div`
	display: flex;
	color: #096dd9;
	font-size: 12px;
	white-space: nowrap;
	//If the text is too long add an ellipsis
	overflow: hidden;
	text-overflow: ellipsis;

	margin-right: 8px;
	span {
		padding: 1px 4px 0;
	}
`;

export default InlineWaiting;
